import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import StatusPill from "@/components/StatusPill";
import api from "@/lib/api";
import { ArrowUpRight } from "@phosphor-icons/react";

export default function AdminRequests() {
  const [items, setItems] = useState([]);
  const [params] = useSearchParams();
  const filter = params.get("status");

  useEffect(() => {
    const url = filter ? `/requests?status=${filter}` : "/requests";
    api.get(url).then((r) => setItems(r.data.items || []));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <div className="App min-h-screen">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10">
        <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-2">Requests</div>
        <h1 className="font-heading font-black tracking-tighter text-4xl md:text-5xl mb-6">All requests {filter ? <span className="text-muted-foreground text-2xl">· {filter.replace(/_/g, " ")}</span> : null}</h1>

        <div className="border border-border bg-white">
          <table className="w-full text-sm">
            <thead className="bg-muted text-left">
              <tr className="text-xs uppercase tracking-widest-2 text-muted-foreground">
                <th className="p-3">Reference</th>
                <th className="p-3">Title</th>
                <th className="p-3">Status</th>
                <th className="p-3">Est. volume</th>
                <th className="p-3">Created</th>
                <th className="p-3"></th>
              </tr>
            </thead>
            <tbody>
              {items.map((r) => (
                <tr key={r.request_id} className="border-t border-border hover:bg-muted/40">
                  <td className="p-3 font-mono text-xs">{r.reference}</td>
                  <td className="p-3 font-medium">{r.title}</td>
                  <td className="p-3"><StatusPill status={r.status} /></td>
                  <td className="p-3">{r.estimated_volume ? r.estimated_volume.toLocaleString() : "—"}</td>
                  <td className="p-3 text-muted-foreground text-xs">{new Date(r.created_at).toLocaleDateString()}</td>
                  <td className="p-3 text-right">
                    <Link to={`/admin/requests/${r.request_id}`} data-testid={`admin-request-link-${r.request_id}`} className="text-primary hover:underline inline-flex items-center gap-1">
                      Open <ArrowUpRight size={12} />
                    </Link>
                  </td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={6} className="p-10 text-center text-muted-foreground">No requests match.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
}
